<app-dialog-content [title]="mode === 'create' ? CREATE_TITLE_LOCALIZED : EDIT_TITLE_LOCALIZED">

    <div class="content">
        <!-- Keyword -->
        <div class="content__item">
            <p class="content__item--header" i18n="Keyword word translation|Translation for the word Keyword@@Keyword">Keyword</p>
            <label for="keyword" style="display:none;">Keyword:</label>
            <input
                class="content__item--input"
                [ngClass]="{'content__item--input__error': !formGroup.controls.keyword.valid && formGroup.controls.keyword.touched}"
                matInput
                type="text"
                [formControl]="formGroup.controls.keyword"
            />
            <!-- required -->
            <mat-error *ngIf="formGroup.controls.keyword.hasError('required') && formGroup.controls.keyword.touched">
                <span i18n="Required Error|Error message displayed for required fileds@@RequiredError" style="font-size: 12px; color: #750000;">*required</span>
            </mat-error>
            <!-- max-length -->
            <mat-error *ngIf="formGroup.controls.keyword.hasError('maxlength') && formGroup.controls.keyword.touched">
                <span i18n="Max Length Error|Error message displayed for fields that exceed 256 characters@@MaxLenghtError" style="font-size: 12px; color: #750000;">*limit 256 characters</span>
            </mat-error>
            <!-- duplicate -->
            <mat-error *ngIf="formGroup.controls.keyword.hasError('duplicate')">
                <span i18n="Duplicate Error|Error message displayed for duplications@@DuplicateError" style="font-size: 12px;">*duplicate</span>
            </mat-error> 
        </div>
        <!-- Definition -->
        <div class="content__item">
            <p class="content__item--header" i18n="Definition word translation|Translation for the word Definition@@Definition">Definition</p>
            <label for="definition" style="display:none;">Definition</label>
            <textarea
                class="content__item--input"
                style="height: 100px;"
                [ngClass]="{'content__item--input__error': !formGroup.controls.definition.valid && formGroup.controls.definition.touched}"
                matInput
                type="text"
                [formControl]="formGroup.controls.definition"
            ></textarea>
            <!-- required -->
            <mat-error *ngIf="formGroup.controls.definition.hasError('required') && formGroup.controls.definition.touched">
                <span i18n="Required Error|Error message displayed for required fileds@@RequiredError" style="font-size: 12px; color: #750000;">*required</span>
            </mat-error>
            <!-- max-length -->
            <mat-error *ngIf="formGroup.controls.definition.hasError('maxlength') && formGroup.controls.definition.touched">
                <span i18n="Max Length Error|Error message displayed for fields that exceed 256 characters@@MaxLenghtError" style="font-size: 12px; color: #750000;">*limit 256 characters</span>
            </mat-error>
        </div>
        <!-- Tags -->
         <div class="content__item">
            <p class="content__item--header" i18n="Select related tag word translation|Translation for the word Select Related Tag@@SelectRelatedTag">Select related tag</p>
            <label for="tag" style="display:none;">Select related tag</label>
            <!-- Options -->
            <mat-select
                class="content__item--select"
                [formControl]="formGroup.controls.tag" 
                [hideSingleSelectionIndicator]="true"
            >
                <mat-option value="N/A">N/A</mat-option>
                <mat-option data-test-id="option" *ngFor="let tag of allTags" [value]="tag">
                    <div data-test-id="value" class="content__item--select__option">
                        {{ tag  }}
                    </div>
                </mat-option>
            </mat-select>
        </div>

    </div>

    
    <!-- Action Buttons -->
    <ng-container uiDialogActions>
        <button mat-flat-button class="action-button" (click)="cancel()"  i18n="Cancel label|Label text for Cancel button@@Cancel">
            Cancel
        </button>
        <button [disabled]="!formGroup.valid" mat-flat-button class="action-button" color="primary" (click)="mode === 'create' ? create() : update()" i18n="Save label|Label text for Save button@@Save">
            Save
        </button>
    </ng-container>
</app-dialog-content>
